import { createFilteredDataSelector } from './create-filtered-data/create-filtered-data.selector';
import { FilterSelectors } from './filter';
import { SearchSelectors } from './search';
import { selectFilterRelatedQueryParamsObject } from './select-filter-related-query-params-object/select-filter-related-query-params-object.selector';
import { SortSelectors } from './sort';

export const DataManipulationSelectors = {
  Filter: FilterSelectors,
  Search: SearchSelectors,
  Sort: SortSelectors,
  Aggregation: {
    createFilteredDataSelector,
    selectFilterRelatedQueryParamsObject
  }
};
